import 'css-chunksrc/client/scenes/projectExpenseEdition/form/elementAttachments/styles.scss';export default {
  "elementAttachments": "_elementAttachments_b43l4_1",
  "label": "_label_b43l4_5",
  "loaderContainer": "_loaderContainer_b43l4_12",
  "attachmentsUploader": "_attachmentsUploader_b43l4_16",
  "dropzone": "_dropzone_b43l4_27",
  "dropPreview": "_dropPreview_b43l4_35",
  "dropPreviewMessage": "_dropPreviewMessage_b43l4_47",
  "attachmentsUploaderContent": "_attachmentsUploaderContent_b43l4_52",
  "text": "_text_b43l4_61",
  "button": "_button_b43l4_66",
  "list": "_list_b43l4_74"
};